export default __webpack_public_path__ + "static/media/luxury.13f4e855.svg";